import React, { useState } from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';

import type { Survey } from 'data/named-content/types';

const reports = [
  {
    title: 'National Surveys',
  },
  {
    title: 'Canadian Market Reports',
    link: 'https://www.zoocasa.com/blog/category/canada/',
  },
  {
    title: 'U.S. Market Reports',
    link: 'https://www.zoocasa.com/blog/category/united-states/',
  },
];

export default function AboutUsReports({ surveys: nationalSurveys }: { surveys: Survey[] }) {
  const [activeReport, setActiveReport] = useState(0);
  const [clickedReport, setClickedReport] = useState(0);
  const isNationalSurveyActive = activeReport === 0;

  return (
    <div className={styles.reports}>
      <div className={styles.container}>
        <span className={styles.divider} />
        <h2>Reports & Research</h2>
        <p>To view all Zoocasa reports, visit our <a href="https://zoocasa.com/blog">blog</a>.</p>
        <div className={styles.reports}>
          <div className={styles['report-titles']}>
            {reports.map((report, index) => {
              const activeClassName = index === activeReport ? styles.active : '';
              const clickedClassName = index === clickedReport ? styles.clicked : '';
              if (report?.link) {
                return <h3 key={index} onClick={() => setClickedReport(index)} onMouseEnter={() => setActiveReport(index)} className={buildClassName(styles.desktop, activeClassName, clickedClassName)}>
                  <a href={report.link} target="_blank" rel="noreferrer">{report.title}</a>
                </h3>;
              }
              return <h3 key={index} onClick={() => setClickedReport(index)} onMouseEnter={() => setActiveReport(index)} className={buildClassName(activeClassName, clickedClassName)}>{report.title}</h3>;
            })}
          </div>
          <div className={styles.surveys}>
            {isNationalSurveyActive && nationalSurveys.map((survey, index) => (
              <a key={index} href={survey.link} target="_blank" rel="noreferrer">{survey.title}</a>
            ))}
          </div>
          <div className={styles.mobile}>
            {reports.map((report, index) => {
              if (report?.link) {
                const activeClassName = index === activeReport ? styles.active : '';
                const clickedClassName = index === clickedReport ? styles.clicked : '';
                return <h3 key={index} onClick={() => setClickedReport(index)} onMouseEnter={() => setActiveReport(index)} className={buildClassName(activeClassName, clickedClassName)}>
                  <a href={report.link} target="_blank" rel="noreferrer">{report.title}</a>
                </h3>;
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
